import SpinCustom from '@/components/common/Spin';
import { addVTAndBHTab } from '@/components/layout/DefaultAction/DefaultAction';
import InputCustom from '@/components/ui/InputCustom';
import ButtonCustom from '@/components/ui/MyButton/Button';
import { useAuth } from '@/contexts/routerProvider/authContext';
import { useIsLogin } from '@/contexts/routerProvider/isLoginContext';
import { useListTab } from '@/contexts/routerProvider/ListTabContext/hook';
import { STORAGE, storage } from '@/lib/storage';
import { MenuItemAdmin } from '@/routerMap/MenuItem';
import { userService } from '@/services/UserService';
import { TabLogin } from '@/types';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import loginFrame from 'src/assets/images/common-icon/Frame_Login.png';
import logo from 'src/assets/images/home/vungtaulab.png';
import '../styles/LoginScreen.scss';
export const findFirstActiveUrl = (data: any, listTab: TabLogin[]): any => {
  const allMenus = data;

  for (const menu of allMenus) {
    const menuStart = listTab?.find(tab =>
      menu?.tabid?.includes(tab?.identity),
    );
    if (menuStart?.identity) {
      if (menu?.key?.includes('grp'))
        return findFirstActiveUrl(menu?.children, listTab);
      if (menu?.children?.length && menu?.key?.includes('subkey'))
        return findFirstActiveUrl(menu?.children, listTab);
      else return menu?.key;
    }
  }
  return '/';
};
const LoginForm = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const { setListTab, setIsListTabLoaded } = useListTab();
  const { setIsLogin } = useIsLogin();
  const { setUser } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (data: { username: string; password: string }) => {
    try {
      setLoading(true);
      const res = await userService.login({
        username: data.username.trim(),
        password: data.password.trim(),
      });
      if (!res.isError) {
        // ✅ Lưu token vào localStorage
        storage.setLocalStorage(STORAGE.TOKEN, res?.data?.token);
        storage.setLocalStorage(STORAGE.USER_INFO, JSON.stringify(res?.data));
        const menu = MenuItemAdmin();
        let listTab: TabLogin[] = res?.data?.listTab ?? [];
        listTab = addVTAndBHTab(listTab, res?.data);
        const listMenu = findFirstActiveUrl(menu, listTab);
        setIsLogin(STORAGE.TOKEN);
        setUser(res?.data);
        navigate(listMenu); // Chuyển sang trang chính
        console.log('Login successful:', listTab, listMenu);

        setListTab(listTab);
        setIsListTabLoaded(true);
      }
    } catch (error) {
      console.log('error>>LoginForm>>:', error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <SpinCustom spinning={loading}>
      <div
        style={{ zIndex: 2, width: '100%', height: '100%' }}
        className="d-flex-center"
      >
        <div className="login-form-wrapper">
          <div className="login-image">
            <img src={loginFrame} alt="Login image" />
          </div>

          <div className="login-form">
            <img src={logo} alt="Logo" className="login-logo-small" />
            <h2 className="login-title">Đăng nhập</h2>

            <Form layout="vertical" onFinish={onSubmit}>
              <Form.Item
                name="username"
                rules={[
                  { required: true, message: 'Vui lòng nhập tài khoản!' },
                ]}
              >
                <InputCustom
                  size="large"
                  prefix={<UserOutlined />}
                  placeholder="Số điện thoại hoặc email"
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[
                  { required: true, message: 'Vui lòng nhập mật khẩu!' },
                  { min: 6, message: 'Mật khẩu ít nhất 6 ký tự!' },
                ]}
              >
                <InputCustom
                  type="password"
                  size="large"
                  prefix={<LockOutlined />}
                  placeholder="Mật khẩu"
                />
              </Form.Item>

              <Form.Item>
                <ButtonCustom
                  htmlType="submit"
                  size="large"
                  className="login-button-primary"
                >
                  Đăng nhập
                </ButtonCustom>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </SpinCustom>
  );
};

export default LoginForm;
